import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';

export default function ArmorySucLoadoutModal({ stateChanger, ...props }) {
  let [isOpen, setIsOpen] = useState(true);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as='div'
          className='fixed inset-0 z-10 overflow-y-auto'
          onClose={() => stateChanger(false)}
        >
          <div className='min-h-screen px-4 text-center'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0'
              enterTo='opacity-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'
            >
              <Dialog.Overlay className='fixed inset-0 bg-black opacity-40' />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className='inline-block h-screen align-middle'
              aria-hidden='true'
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <div className='inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-gray-700 shadow-xl rounded-2xl'>
                <Dialog.Title
                  as='h3'
                  className='text-xl font-medium leading-6 text-gray-100'
                >
                  {props.title}
                </Dialog.Title>
                <div className='mt-2'>
                  <p className='text-sm text-gray-300'>{props.msg}</p>
                </div>

                <div className='mt-4'>
                  <button
                    type='button'
                    className='inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-100 bg-illOrange-500 border border-transparent rounded-md hover:bg-illOrange-400 focus:outline-none focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:ring-illOrange-600'
                    // onClick={closeModal}
                    onClick={() => {
                      stateChanger(false);
                      // closeModal;
                    }}
                  >
                    {props.btnText}
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
